import { CheckListItemModel } from 'libs/core/src/lib/model/checklistitem.model';

export enum RefundTypeEnum {
  Items = 'items',
  Vouchers = 'vouchers'
}

export interface RefundModalContent {
  refundType: RefundTypeEnum;

  items: CheckListItemModel[];

  successContent?: RefundModalSuccessContent;
  failedContent?: RefundModalFailedContent;
}

export interface RefundModalFailedContent {
  timeBeforeScreening?: number;
  isRefundable?: boolean;
  error?: any;
}

export interface RefundModalSuccessContent {
  refundedItemsCount: number;
  allItemsCount: number;
}
